
/* ============================== src/api/queries/departments.js ============================== */
// src/api/queries/departments.js
/**
 * Хуки для работы с отделами.
 * 
 * Метод useUpsertDepartmentMutation всегда использует POST /departments,
 * так как бэкенд (department.routes.ts) реализует логику upsert (создание
 * или обновление) внутри POST-запроса на основе поля id в теле.
 * Ранее фронтенд пытался делать PATCH /departments/:id при наличии id,
 * что приводило к 404 (Route not found), так как PATCH-роута на бэкенде нет.
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const DEPARTMENTS_KEY = ["departments"];

export function useDepartmentsQuery(options = {}) {
  return useQuery({
    queryKey: DEPARTMENTS_KEY,
    queryFn: () => api.get("/departments"),
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useUpsertDepartmentMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }) =>
      api.post("/departments", { ...body, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: DEPARTMENTS_KEY }),
  });
}

export function useDeleteDepartmentMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/departments/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: DEPARTMENTS_KEY }),
  });
}
